<adaa-data-table
    [titleHeader]="title()"
    [configKey]="tableConfig()"
    [enableExport]="false"
    [enableAdd]="true"
    [enableViewAction]="false"
    [isLocalData]="true"
    [localData]="subMilestonesData"
    (addNewClicked)="addNewClicked()"
    (actionClicked)="actionClicked($event)"
></adaa-data-table>
